<input type="text" pInputText
#inputField
[value]="value"
[formControl]="inputControl" 
tooltip 
[tooltipTitle]="tooltipMessage" 
tooltipPosition="right" 
tooltipClass="error"
[tooltipHorizontalOffset]="8"
(input)="onInputChange()"
(focus)="onFocus()"
(focusout)="onBlur()"
(keyup.enter)="blurInput()"
[placeholder]="placeholder"
[style.width]="width" 
[minlength]="min"
[maxlength]="max"
[autofocus]="autofocus"
[attr.disabled]="getEnabledState()"
autocomplete="off"
autocorrect="off" 
autocapitalize="off" 
spellcheck="false">
